export default __webpack_public_path__ + "static/media/image.shield-technologies-pvt-ltd.c7738e46.png";